import React, { useState, useEffect } from "react";
import FlipMove from "react-flip-move";
import { CheckIcon } from "@heroicons/react/20/solid";

export default function Carousel() {
  const initialItems = [
    { name: "Tom Belfort", time: "12:01 PM", date: "26/5/2023" },
    { name: "Zig Ziglar", time: "12:16 PM", date: "27/5/2023" },
    { name: "Aaron Ross", time: "12:46 PM", date: "28/5/2023" },
    { name: "Mary Ash", time: "1:01 PM", date: "29/5/2023" },
  ];
  const [items, setItems] = useState(initialItems);
  const [counter, setCounter] = useState(2);

  useEffect(() => {
    const interval = setInterval(() => {
      setItems((prevItems) => {
        const newItems = [...prevItems];
        const lastItem = newItems.pop();
        return [lastItem, ...newItems];
      });
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter((prevCounter) => {
        return prevCounter >= 7 ? 2 : prevCounter + 1;
      });
    }, 500);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="lg:h-[50vh] max-w-md mx-auto overflow-hidden">
      <FlipMove>
        {items.map((item, idx) => (
          <div
            key={item.name}
            className="mb-4 p-4 border border-gray-100 bg-white shadow-sm rounded-lg  grid grid-cols-5 justify-between"
          >
            <div className="col-span-3">
              <p className="text-xl font-header">
                {idx < 1
                  ? "Incoming Patient"
                  : idx < 2
                  ? "Appointment"
                  : idx < 3
                  ? "Transcribing Notes"
                  : "Formatted Docs"}
              </p>
              <p className="text-gray-400 text-sm mt-3 font-header">
                {idx < 2
                  ? `${item.name} at ${item.time}`
                  : idx < 3
                  ? `${counter} items added to SOAP `
                  : `Added to EMR`}
              </p>
            </div>
            <div className="col-span-2">
              {idx < 1 ? (
                <p className="font-semibold text-center  bg-zinc-300 rounded-lg p-4  w-42">
                  Incoming -
                </p>
              ) : idx < 2 ? (
                <p className="font-semibold text-center  bg-zinc-300 rounded-lg p-4  w-42">
                  Consulting...
                </p>
              ) : idx < 3 ? (
                <p className="font-semibold items-center justify-center bg-blue-500 text-white rounded-lg p-4 flex flex-row gap-2">
                  Formatting{" "}
                  <svg
                    className="animate-spin h-5 w-5  self-center"
                    fill="currentColor"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 40 40"
                    enableBackground="new 0 0 40 40"
                    xml="preserve"
                  >
                    <path
                      opacity="0.2"
                      d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"
                    />
                    <path d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z" />
                  </svg>
                </p>
              ) : (
                <p className="font-semibold items-center justify-center bg-green-500 text-white rounded-lg p-4 flex flex-row gap-2">
                  Automated
                  <CheckIcon className="h-6 w-6" />
                </p>
              )}
            </div>
          </div>
        ))}
      </FlipMove>
    </div>
  );
}
